import Vue from 'vue';
import UninetVuetify from 'uninet-vuetify';

Vue.use(UninetVuetify);
